export const SET_M7_REQUEST = 'SET_M7_REQUEST';
export const SET_M7_FAILED = 'SET_M7_FAILED';
export const SET_M7_SEGMENTS_SUCCESS = 'SET_M7_SEGMENTS_SUCCESS';
export const CLEAN_M7 = 'CLEAN_M7';
